import { ReactNode, StrictMode } from 'react';

export const DevelopmentContext = ({ children }: { children: ReactNode }) => <StrictMode>{children}</StrictMode>;
